// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.messages[data-v-10c704e2] {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  padding: 16px 8px 8px;
  scrollbar-width: none;
  text-align: left;
}
.messages[data-v-10c704e2]::-webkit-scrollbar {
  display: none;
}
.chat-message[data-v-10c704e2] {
  align-self: flex-start;
  width: 100%;
  padding: 8px;
  border-radius: 10px;
}
.user-message[data-v-10c704e2] {
  background-color: #fff;
}
.reply-status[data-v-10c704e2] {
  padding: 8px 12px;
  color: #8e999e;
}
.formatted-message[data-v-10c704e2] p:last-child {
  margin-bottom: 0;
}
.formatted-message[data-v-10c704e2] h1,
.formatted-message[data-v-10c704e2] h2,
.formatted-message[data-v-10c704e2] h3 {
  margin: 16px 0 8px;
  color: #5f6b71;
  line-height: 1.35;
}
.formatted-message[data-v-10c704e2] h1:first-child,
.formatted-message[data-v-10c704e2] h2:first-child,
.formatted-message[data-v-10c704e2] h3:first-child {
  margin-top: 0;
}
.formatted-message[data-v-10c704e2] h1 {
  font-size: 20px;
}
.formatted-message[data-v-10c704e2] h2 {
  font-size: 18px;
}
.formatted-message[data-v-10c704e2] h3 {
  font-size: 16px;
}
.formatted-message[data-v-10c704e2] pre {
  margin: 8px 0;
  padding: 12px;
  overflow-x: auto;
  border-radius: 6px;
  background-color: #fff;
  color: #5f6b71;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.formatted-message[data-v-10c704e2] pre code {
  padding: 0;
  background: transparent;
  color: inherit;
  font-family: inherit;
  white-space: inherit;
}
.message-text[data-v-10c704e2] {
  margin: 0;
}
.message-text[data-v-10c704e2]:not(.formatted-message) {
  white-space: pre-wrap;
}
.file-chip[data-v-10c704e2] {
  display: flex;
  width: fit-content;
  max-width: 100%;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  overflow-wrap: anywhere;
  border: 1px solid #d9dfe2;
  border-radius: 5px;
  background-color: #fff;
}
.file-name[data-v-10c704e2] {
  min-width: 0;
  overflow-wrap: anywhere;
}
.message-text + .file-chip[data-v-10c704e2] {
  margin-top: 6px;
}
.next-step-cont[data-v-10c704e2] {
  padding: 8px;
}
.next-step-actions[data-v-10c704e2] {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-top: 10px;
}
.next-step-btn[data-v-10c704e2] {
  min-height: 40px;
  color: #5f6b71;
  background-color: transparent;
  border: 1px solid #b1babe;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
}
.next-step-btn[data-v-10c704e2]:hover {
  background-color: #e9ebec;
}
`, "",{"version":3,"sources":["webpack://./src/view/components/autoAIAgent/AutoAIAgentMessages.vue"],"names":[],"mappings":";AAyFA;EACE,aAAa;EACb,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;AAEA;EACE,aAAa;AACf;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AAEA;EACE,gBAAgB;AAClB;AAEA;;;EAGE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AAEA;;;EAGE,aAAa;AACf;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;AACtB;AAEA;EACE,SAAS;AACX;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,YAAY;AACd;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["<script setup lang=\"ts\">\nimport type { AutoAIAgentChatMessage, PendingMessage } from './autoAIAgent';\n\ntype FormattableMessage = {\n  Message?: string;\n  MessageRaw?: string;\n};\n\ndefineProps<{\n  historyMessages: AutoAIAgentChatMessage[];\n  pendingMessage: PendingMessage | null;\n  showReplyStatus: boolean;\n  showNextStepActions: boolean;\n}>();\n\ndefineEmits<{\n  'use-prompt': [];\n  'modify-prompt': [];\n}>();\n\nfunction hasRawMessageContent(message: FormattableMessage): boolean {\n  return (message.MessageRaw?.trim().length ?? 0) > 0;\n}\n\nfunction hasFormattedMessageContent(message: FormattableMessage): boolean {\n  if (!message.Message) {\n    return false;\n  }\n\n  const parsedDocument = new DOMParser().parseFromString(message.Message, 'text/html');\n  return (parsedDocument.body.textContent || '').trim().length > 0;\n}\n</script>\n\n<template>\n  <div class=\"messages\">\n    <div v-if=\"historyMessages.length === 0\" class=\"mx-2 mb-2 font-xsm\">\n      こんにちは。<br>\n      AIを活用したシフト作成をお手伝いします。<br>\n      まず、現在のシフト表のサンプルとなるExcel（またはCSV）ファイルをアップロードしてください。シフトのパターンを分析します。\n    </div>\n\n    <div\n      v-for=\"(message, index) in historyMessages\"\n      :key=\"index\"\n      class=\"chat-message font-sm\"\n      :class=\"{ 'user-message': !message.isAgent }\"\n    >\n      <div v-if=\"hasRawMessageContent(message)\" class=\"message-text\">{{ message.MessageRaw }}</div>\n      <div v-else-if=\"hasFormattedMessageContent(message)\" class=\"message-text formatted-message\" v-html=\"message.Message\"></div>\n      <div v-if=\"message.filename\" class=\"file-chip\">\n        <span class=\"file-name\">{{ message.filename }}</span>\n      </div>\n      <div v-if=\"message.fileWarning\" class=\"oplus-delete-text mt-1\">\n        {{ message.fileWarning }}\n      </div>\n    </div>\n\n    <div v-if=\"pendingMessage\" class=\"chat-message user-message font-sm\">\n      <div v-if=\"hasRawMessageContent(pendingMessage)\" class=\"message-text\">{{ pendingMessage.MessageRaw }}</div>\n      <div v-else-if=\"hasFormattedMessageContent(pendingMessage)\" class=\"message-text formatted-message\" v-html=\"pendingMessage.Message\"></div>\n      <div v-else-if=\"pendingMessage.text\" class=\"message-text\">{{ pendingMessage.text }}</div>\n      <div v-if=\"pendingMessage.fileName\" class=\"file-chip\">\n        {{ pendingMessage.fileName }}\n      </div>\n    </div>\n\n    <div v-if=\"showReplyStatus\" class=\"reply-status font-sm\">\n      シフトエージェントが回答を作成しています...\n    </div>\n\n    <div v-if=\"showNextStepActions\" class=\"next-step-cont\">\n      <div class=\"font-xsm\">\n        どのように進めますか？<br>\n        上記のルールをコピーしてシフト作成に使用することもできます。また、ルールを変更することもできます。\n      </div>\n      <div class=\"next-step-actions\">\n        <button class=\"next-step-btn\" type=\"button\" @click=\"$emit('use-prompt')\">\n          このルールを使用\n        </button>\n        <button class=\"next-step-btn\" type=\"button\" @click=\"$emit('modify-prompt')\">\n          ルールを変更\n        </button>\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n.messages {\n  display: flex;\n  min-height: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n  padding: 16px 8px 8px;\n  scrollbar-width: none;\n  text-align: left;\n}\n\n.messages::-webkit-scrollbar {\n  display: none;\n}\n\n.chat-message {\n  align-self: flex-start;\n  width: 100%;\n  padding: 8px;\n  border-radius: 10px;\n}\n\n.user-message {\n  background-color: #fff;\n}\n\n.reply-status {\n  padding: 8px 12px;\n  color: #8e999e;\n}\n\n.formatted-message :deep(p:last-child) {\n  margin-bottom: 0;\n}\n\n.formatted-message :deep(h1),\n.formatted-message :deep(h2),\n.formatted-message :deep(h3) {\n  margin: 16px 0 8px;\n  color: #5f6b71;\n  line-height: 1.35;\n}\n\n.formatted-message :deep(h1:first-child),\n.formatted-message :deep(h2:first-child),\n.formatted-message :deep(h3:first-child) {\n  margin-top: 0;\n}\n\n.formatted-message :deep(h1) {\n  font-size: 20px;\n}\n\n.formatted-message :deep(h2) {\n  font-size: 18px;\n}\n\n.formatted-message :deep(h3) {\n  font-size: 16px;\n}\n\n.formatted-message :deep(pre) {\n  margin: 8px 0;\n  padding: 12px;\n  overflow-x: auto;\n  border-radius: 6px;\n  background-color: #fff;\n  color: #5f6b71;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.formatted-message :deep(pre code) {\n  padding: 0;\n  background: transparent;\n  color: inherit;\n  font-family: inherit;\n  white-space: inherit;\n}\n\n.message-text {\n  margin: 0;\n}\n\n.message-text:not(.formatted-message) {\n  white-space: pre-wrap;\n}\n\n.file-chip {\n  display: flex;\n  width: fit-content;\n  max-width: 100%;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  overflow-wrap: anywhere;\n  border: 1px solid #d9dfe2;\n  border-radius: 5px;\n  background-color: #fff;\n}\n\n.file-name {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.message-text + .file-chip {\n  margin-top: 6px;\n}\n\n.next-step-cont {\n  padding: 8px;\n}\n\n.next-step-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.next-step-btn {\n  min-height: 40px;\n  color: #5f6b71;\n  background-color: transparent;\n  border: 1px solid #b1babe;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.next-step-btn:hover {\n  background-color: #e9ebec;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
